module.exports = __webpack_public_path__ + "assets/static/png/ico-visa-min.7ee8df6d5676e25c46006999cb538be1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/payments/images/ico-visa-min.png
 ** module id = 537
 ** module chunks = 1
 **/